/**
 * jumelage-demo.ts — S232 lot 16 (P-S232-10 ; DEC-PLAN-DEMO-2 « 7aetb », DEC-PLAN-DEMO-3 « 1a ») : le jumelage dans l'entrée « Jumelage » du
 * Blueprint d'Orbit9, compte démo seulement. Découpage choisi par Claude AI (ECHANGES-AP-DEV EX-103) sur les 5 étapes du pipeline de
 * SectionJumelage (Orbit9Blueprint.tsx) : pour chaque étape, les écrans de la maquette du flux Usine Bleue qui la composent (rangée C de
 * docs/MAQUETTE-FLUX-USINE-BLEUE.md) et la ou les parties de la simulation du jumelage (PhaseConceptionJumelage, galerie des simulations).
 * Fonctions pures, exécutées par tests/test_s232_lot16_jumelage_js.py (esbuild → node).
 */

export interface EtapeJumelage {
  titre: string;
  /** Écrans de la maquette du flux Usine Bleue (rangée C, jumelage) */
  ecrans: string[];
  /** Parties de la simulation, dans l'ordre du découpage */
  parties: string[];
  /** stage de PhaseConceptionJumelage qui met en avant la partie à montrer (1 Critères … 5 Recommandation) ; 0 : aucune simulation */
  stage: number;
  phrase?: string;
}

export const ETAPES_JUMELAGE: EtapeJumelage[] = [
  { titre: "Découverte", ecrans: ["Profil recherché", "Description anonyme"], parties: ["Critères"], stage: 1 },
  { titre: "Qualification", ecrans: ["Critères du client", "Envoi de l'appel", "Gestion des mains levées"], parties: ["Scan réseau"], stage: 2 },
  { titre: "Introduction", ecrans: ["Classement complet", "Session ConférenceAI"], parties: ["Scoring", "Conférences AI"], stage: 4 },
  { titre: "Collaboration", ecrans: ["Visites et suivi", "Top 3 et NDA"], parties: ["Recommandation"], stage: 5 },
  { titre: "Intégration", ecrans: [], parties: [], stage: 0, phrase: "Le projet démarre avec l'intégrateur retenu." },
];

/** Le contenu d'une étape du pipeline (0 à 4), ou null hors des 5 étapes. */
export function contenuEtapeJumelage(i: number): EtapeJumelage | null {
  return ETAPES_JUMELAGE[i] || null;
}

/** Les étapes du pipeline ne sont cliquables que pour le compte démo ; pour tout autre compte, SectionJumelage reste comme avant. */
export function etapesCliquables(estDemo: boolean): boolean {
  return estDemo === true;
}
